import React from 'react';
import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';
import { BarChart3, Receipt, ClipboardList } from 'lucide-react';
import { cn } from '../../lib/utils';

interface SidebarProps {
    isOpen: boolean;
    onToggle: () => void;
}

const navigation = [
    {
        name: 'Analytics',
        href: '/events',
        icon: BarChart3,
    },
    // {
    //     name: 'Transactions',
    //     href: '/transactions',
    //     icon: Receipt,
    // },
    {
        name: 'Muster Count',
        href: '/muster-count',
        icon: ClipboardList,
    },
    // {
    //     name: 'Integrity Checker',
    //     href: '/integrity-checker',
    //     icon: ShieldCheck,
    // },
    // {
    //     name: 'Attendance Records',
    //     href: '/attendance',
    //     icon: Users,
    // },
    // {
    //     name: 'Settings',
    //     href: '/settings',
    //     icon: Settings,
    // },
];

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onToggle }) => {
    return (
        <>
            {/* Mobile overlay */}
            {isOpen && <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={onToggle} />}

            {/* Sidebar */}
            <motion.aside
                initial={false}
                animate={{
                    x: isOpen ? 0 : '-100%',
                }}
                transition={{ type: 'spring', damping: 30, stiffness: 300 }}
                className={cn(
                    'fixed top-0 left-0 z-50 h-full w-64 bg-white border-r border-gray-200 shadow-lg lg:relative lg:translate-x-0 lg:shadow-none',
                    // On mobile: show when open, hide when closed. On large screens: always visible.
                    isOpen ? 'flex flex-col' : 'hidden',
                    'lg:flex lg:flex-col'
                )}
            >
                {/* Sidebar Header */}
                <div className="flex items-center justify-center h-20 px-6 border-b border-gray-200">
                    <div className="flex items-center h-20 space-x-1">
                        <img src="/assets/ic_logo.png" alt="Drishti Logo" className="h-full object-contain w-full" />
                        {/* <span className="text-lg font-semibold text-gray-800 whitespace-nowrap">Admin Panel</span> */}
                    </div>
                </div>

                {/* Navigation */}
                <nav className="flex-1 px-4 py-6 space-y-2">
                    {navigation.map((item, index) => (
                        <motion.div key={item.name} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: index * 0.1 }}>
                            <NavLink
                                to={item.href}
                                className={({ isActive }) => cn('flex items-center space-x-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors', isActive ? 'bg-[#487875] text-white border-r-2 border-[#487875]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900')}
                                onClick={() => {
                                    // Close mobile sidebar when navigating
                                    if (window.innerWidth < 1024) {
                                        onToggle();
                                    }
                                }}
                            >
                                <item.icon className="w-5 h-5" />
                                <span>{item.name}</span>
                            </NavLink>
                        </motion.div>
                    ))}
                </nav>

                {/* Footer */}
                <div className="p-4 border-t border-gray-200 space-y-3">
                    <div className="flex justify-center h-8">
                        {/* <a href="https://www.chaincodeconsulting.com" target="_blank" rel="noopener noreferrer" className="inline-block hover:opacity-80 transition-opacity">
                            <img src="/assets/powered-by-chaincode.png" alt="Powered by ChainCode Consulting" className="h-8 w-auto" />
                        </a> */}
                        <img src="/assets/ic_drishti_logo.png" alt="Drishti Logo" className="w-auto" />
                    </div>
                    <div className="text-xs text-gray-500 text-center">© {new Date().getFullYear()} Drishti Analytics</div>
                </div>
            </motion.aside>
        </>
    );
};

export default Sidebar;
